export { default } from './HyperLink';
export type { IHyperLinkProps, THyperLinkVariant } from './HyperLink';
